function sortOnDrinkingTime(array) {
    array.sort((a, b) => {
        const da = a.time.season23_24;
        const db = b.time.season23_24;
        return db -da;
    });
}

export default sortOnDrinkingTime;